import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  Collapse,
  Input,
  Label,
  Button,
  UncontrolledTooltip,
  TabPane,
} from "reactstrap"
import PeriodBtn from '../../components/Filter/PeriodBtn';
import { Link } from "react-router-dom";
import Select from "react-select";
import "toastr/build/toastr.min.css"
import { useDispatch } from "react-redux";

function UploadedContacts( {
    isOpen,
    activeTab,
    filterValidation,
    countryList,
    uploadContactsHistory,
    noticeStrUp,
    uploadedContactsList,
    setConfirmMsg,
    setConfirmAlert,
    toggle,
    setCurPageInputUp,
    saveValidationUp,
    contactChkUp,
    entityCheckUp,
    handleInputUp,
    viewContactsListUp,
    onSetUploadContactsOpen,
    chkAllFlagUp,
    totalPageUp,
    curPageInputUp
}) {

    const dispatch = useDispatch();

    return (
        <TabPane tabId="Upload">
            <Row>
                <Col lg={12}>
                    <Card>
                        <Link onClick={toggle} className="text-dark" to="#">
                            <div className="p-4">
                                <Media className="d-flex align-items-center">
                                    <div className="flex-shrink-0 me-3">
                                        <i className="uil uil-at text-primary h2"></i>
                                    </div>
                                    <div className="flex-grow-1 overflow-hidden">
                                        <h5 className="font-size-16 mb-1">Imported Email Addresses</h5>
                                        <p className="text-muted mb-0">Bulk import email addresses via CSV file and manage imported email addresses</p>
                                    </div>
                                    <i className="uil uil-filter font-size-24"></i>
                                </Media>
                            </div>
                        </Link>
                        <Collapse isOpen={isOpen}>
                            <div className="p-4 border-top">
                                <div>
                                    <Row className="mb-3 col-md-6">
                                        <Button type="button" color="danger" className="waves-effect waves-light"
                                            onClick={() => { dispatch(onSetUploadContactsOpen(true)); }}
                                            id={"uploadCsv"}
                                        > <i className="uil uil-upload-alt"></i> Import email addresses
                                        </Button>
                                        <UncontrolledTooltip placement="top" target={"uploadCsv"}>
                                            Import email addresses (csv file)
                                        </UncontrolledTooltip>
                                    </Row>
                                    {
                                        uploadContactsHistory && uploadContactsHistory.length ?
                                            <><Row className="mb-3">
                                                <h5 className="font-size-16 mb-1 mt-2">
                                                    <i className="uil uil-history"></i> Import history
                                                </h5>
                                            </Row>
                                                <Row>
                                                    <Col lg={12}>
                                                        <div className="table-responsive">
                                                            <Table className="table mb-0" style={{ width: "800px" }}>
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ paddingLeft: "0px" }}><div style={{ paddingBlock: "16px" }}>File name</div></th>
                                                                        <th style={{ paddingLeft: "0px" }}>
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: "3px" }}>
                                                                                <span>Imported date</span>
                                                                                <span style={{ display: 'flex', flexDirection: "column", alignItems: 'center', justifyContent: 'center' }}>
                                                                                    <Link to='#'
                                                                                        onClick={() => {
                                                                                            filterValidation.setFieldValue("importHisSortType", "IDA");
                                                                                            filterValidation.setFieldValue("submitType", "viewUp");
                                                                                            filterValidation.handleSubmit(filterValidation.values);
                                                                                        }}
                                                                                        className={filterValidation.values.importHisSortType == "IDA" ? "text-danger" : ""}
                                                                                    >
                                                                                        <i className="uil uil-angle-up font-size-18"></i>
                                                                                    </Link>
                                                                                    <Link to='#'
                                                                                        onClick={() => {
                                                                                            filterValidation.setFieldValue("importHisSortType", "IDA");
                                                                                            filterValidation.setFieldValue("submitType", "viewUp");
                                                                                            filterValidation.handleSubmit(filterValidation.values);
                                                                                        }}
                                                                                        className={filterValidation.values.importHisSortType == "IDD" ? "text-danger" : ""}
                                                                                    >
                                                                                        <i className="uil uil-angle-down font-size-18"></i>
                                                                                    </Link>
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th style={{ paddingLeft: "0px" }}><div style={{ paddingBlock: "16px" }}>New contacts imported</div></th>
                                                                        <th style={{ paddingLeft: "0px" }}></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        uploadContactsHistory.map((entity, entityIdx) => {
                                                                            return (
                                                                                <tr key={entityIdx}>
                                                                                    <td style={{ paddingLeft: "0px" }}>{entity.fileName}</td>
                                                                                    <td style={{ paddingLeft: "0px" }}>{entity.importDate}</td>
                                                                                    <td style={{ paddingLeft: "0px" }}>{entity.newContactsCount}</td>
                                                                                    {
                                                                                        entity.newContactsCount > 0 &&
                                                                                        <td style={{ paddingLeft: "0px" }}>
                                                                                            <i
                                                                                                className="uil uil-trash-alt text-danger font-size-18"
                                                                                                style={{ cursor: "pointer" }}
                                                                                                onClick={() => {
                                                                                                    filterValidation.setFieldValue("submitType", "delUpByFile_" + entity.seq);
                                                                                                    setConfirmMsg(`Are you sure you want to delete emails imported from ${entity.fileName} on ${entity.importDate}?`);
                                                                                                    setConfirmAlert(true);
                                                                                                }}
                                                                                            >
                                                                                            </i>
                                                                                        </td>
                                                                                    }
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </Col>
                                                </Row></> : null
                                    }
                                    <Row className="mb-3">
                                        <h5 className="font-size-16 mb-1 mt-3"><i className="uil uil-search"></i> Search existing imports</h5>
                                    </Row>
                                    <Row className="mb-3">
                                        <label htmlFor="emailAddress" className="col-md-3 col-form-label">
                                            Email address
                                        </label>
                                        <div className="col-md-3">
                                            <Input className="form-control"
                                                type="text"
                                                placeholder="Email address"
                                                id="emailAddress"
                                                name="emailAddress"
                                                onChange={filterValidation.handleChange}
                                                value={filterValidation.values.emailAddress}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setCurPageInputUp(1);
                                                        filterValidation.setFieldValue("curPageUp", 1);
                                                        filterValidation.setFieldValue("submitType", "viewUp");
                                                        filterValidation.handleSubmit(filterValidation.values);
                                                    }
                                                }}
                                            /></div>
                                    </Row>
                                    <Row className="mb-3">
                                        <label htmlFor="firstName" className="col-md-3 col-form-label">
                                            First name
                                        </label>
                                        <div className="col-md-3">
                                            <Input className="form-control"
                                                type="text"
                                                placeholder="First name"
                                                id="firstName"
                                                name="firstName"
                                                onChange={filterValidation.handleChange}
                                                value={filterValidation.values.firstName}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setCurPageInputUp(1);
                                                        filterValidation.setFieldValue("curPageUp", 1);
                                                        filterValidation.setFieldValue("submitType", "viewUp");
                                                        filterValidation.handleSubmit(filterValidation.values);
                                                    }
                                                }}
                                            /></div>
                                    </Row>
                                    <Row className="mb-3">
                                        <label htmlFor="lastName" className="col-md-3 col-form-label">
                                            Last name
                                        </label>
                                        <div className="col-md-3">
                                            <Input className="form-control"
                                                type="text"
                                                placeholder="Last name"
                                                id="lastName"
                                                name="lastName"
                                                onChange={filterValidation.handleChange}
                                                value={filterValidation.values.lastName}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setCurPageInputUp(1);
                                                        filterValidation.setFieldValue("curPageUp", 1);
                                                        filterValidation.setFieldValue("submitType", "viewUp");
                                                        filterValidation.handleSubmit(filterValidation.values);
                                                    }
                                                }}
                                            /></div>
                                    </Row>
                                    <Row className="mb-3">
                                        <label htmlFor="title" className="col-md-3 col-form-label">
                                            Title
                                        </label>
                                        <div className="col-md-3">
                                            <Input className="form-control"
                                                type="text"
                                                placeholder="Title of contact"
                                                id="title"
                                                name="title"
                                                onChange={filterValidation.handleChange}
                                                value={filterValidation.values.title}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setCurPageInputUp(1);
                                                        filterValidation.setFieldValue("curPageUp", 1);
                                                        filterValidation.setFieldValue("submitType", "viewUp");
                                                        filterValidation.handleSubmit(filterValidation.values);
                                                    }
                                                }}
                                            /></div>
                                    </Row>
                                    <Row className="mb-3">
                                        <label htmlFor="position" className="col-md-3 col-form-label">
                                            Position
                                        </label>
                                        <div className="col-md-3">
                                            <Input className="form-control"
                                                type="text"
                                                placeholder="Position of contact"
                                                id="position"
                                                name="position"
                                                onChange={filterValidation.handleChange}
                                                value={filterValidation.values.position}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setCurPageInputUp(1);
                                                        filterValidation.setFieldValue("curPageUp", 1);
                                                        filterValidation.setFieldValue("submitType", "viewUp");
                                                        filterValidation.handleSubmit(filterValidation.values);
                                                    }
                                                }}
                                            /></div>
                                    </Row>

                                    <Row className="mb-3">
                                        <label htmlFor="country" className="col-md-3 col-form-label">
                                            Country
                                        </label>
                                        <div className="col-md-3">
                                            <Select
                                                classNamePrefix="select2-selection"
                                                name="country"
                                                placeholder="Select country"
                                                options={
                                                    countryList
                                                        .sort((a, b) => a.crCode.localeCompare(b.crCode))
                                                        .map(c => ({ value: c.crCode, label: `${c.crCode} ${c.crName}` }))
                                                }
                                                value={
                                                    filterValidation.values.country ?
                                                        countryList
                                                            .filter(c => c.crCode == filterValidation.values.country)
                                                            .map(c => ({ value: c.crCode, label: `${c.crCode} ${c.crName}` }))
                                                        : ""
                                                }
                                                isClearable
                                                isSearchable
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                styles={{
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "clip",
                                                    })
                                                }}
                                                onChange={(selectedOption) => {
                                                    filterValidation.setFieldValue("country", selectedOption ? selectedOption.value : '')
                                                }}
                                            />

                                        </div>
                                    </Row>

                                    <Row className="mb-3">
                                        <label htmlFor="office" className="col-md-3 col-form-label">
                                            Office
                                        </label>
                                        <div className="col-md-3">
                                            <Input className="form-control"
                                                type="text"
                                                placeholder="Office of contact"
                                                id="office"
                                                name="office"
                                                onChange={filterValidation.handleChange}
                                                value={filterValidation.values.office}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setCurPageInputUp(1);
                                                        filterValidation.setFieldValue("curPageUp", 1);
                                                        filterValidation.setFieldValue("submitType", "viewUp");
                                                        filterValidation.handleSubmit(filterValidation.values);
                                                    }
                                                }}
                                            /></div>
                                        <button type="button" className="waves-effect waves-light btn btn-primary col-md-3" style={{ width: '148.58px' }}
                                            onClick={() => {
                                                setCurPageInputUp(1);
                                                filterValidation.setFieldValue("curPageUp", 1);
                                                filterValidation.setFieldValue("submitType", "viewUp");
                                                filterValidation.handleSubmit(filterValidation.values);
                                            }}
                                        > Search
                                        </button>
                                    </Row>
                                </div>
                            </div>
                        </Collapse>
                    </Card>
                </Col>
            </Row>
            {activeTab == "Upload" && noticeStrUp && noticeStrUp !== '' ?
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <CardTitle className="text-muted mb-0">
                                    <span>{noticeStrUp}</span>
                                </CardTitle>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                : null}
            {uploadedContactsList && uploadedContactsList.length ?
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <CardTitle className="text-muted mb-0">
                                    <Row className="mb-3">
                                        <span className="col-md-6 button-items">
                                            <Button type="button" color="primary" outline className="waves-effect waves-light"
                                                onClick={() => {
                                                    if (saveValidationUp()) {
                                                        filterValidation.setFieldValue("submitType", "saveUp");
                                                        setConfirmMsg("Are you sure you want to save the selected email(s)?");
                                                        setConfirmAlert(true);
                                                    }
                                                }}
                                                id={"save-contact"}
                                            >Save contact
                                            </Button>
                                            <Button type="button" color="primary" outline className="waves-effect waves-light"
                                                onClick={() => {
                                                    if (contactChkUp()) {
                                                        filterValidation.setFieldValue("submitType", "deleteUp");
                                                        setConfirmMsg("Are you sure you want to delete the selected email(s)?");
                                                        setConfirmAlert(true);
                                                    }
                                                }}
                                                id={"delete-contact"}
                                            >Delete contact
                                            </Button>
                                        </span>
                                    </Row>
                                </CardTitle>
                                <div className="table-responsive">
                                    <Table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ verticalAlign: "middle", textAlign: "center" }}><input type="checkbox" checked={chkAllFlagUp} onClick={(e) => entityCheckUp("chkAll", e)} /></th>
                                                <th>Email address*</th>
                                                <th>First name</th>
                                                <th>Last name</th>
                                                <th>Title</th>
                                                <th>Position</th>
                                                <th>Country</th>
                                                <th>Office</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                uploadedContactsList.map((entity, entityIdx) => {
                                                    return (
                                                        <tr key={entityIdx}>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                <input type="checkbox"
                                                                    checked={entity.checked}
                                                                    onClick={(e) => entityCheckUp(entityIdx, e)}
                                                                />
                                                            </td>
                                                            <td>{entity.emailAddress}</td>
                                                            <td><input type="text" className="form-control" onChange={(e) => { handleInputUp("firstName", entityIdx, e.target.value) }} value={entity.firstName ? entity.firstName : ""} /></td>
                                                            <td><input type="text" className="form-control" onChange={(e) => { handleInputUp("lastName", entityIdx, e.target.value) }} value={entity.lastName ? entity.lastName : ""} /></td>
                                                            <td><input type="text" className="form-control" onChange={(e) => { handleInputUp("title", entityIdx, e.target.value) }} value={entity.title ? entity.title : ""} /></td>
                                                            <td><input type="text" className="form-control" onChange={(e) => { handleInputUp("position", entityIdx, e.target.value) }} value={entity.position ? entity.position : ""} /></td>
                                                            <td>
                                                                <Select
                                                                    classNamePrefix="select2-selection"
                                                                    name="country"
                                                                    placeholder="Select country"
                                                                    options={
                                                                        countryList
                                                                            .sort((a, b) => a.crCode.localeCompare(b.crCode))
                                                                            .map(c => ({ value: c.crCode, label: `${c.crCode} ${c.crName}` }))
                                                                    }
                                                                    value={
                                                                        entity.country ?
                                                                            countryList
                                                                                .filter(c => c.crCode == entity.country)
                                                                                .map(c => ({ value: c.crCode, label: `${c.crCode} ${c.crName}` }))
                                                                            : ""
                                                                    }
                                                                    isClearable
                                                                    isSearchable
                                                                    menuPlacement="auto"
                                                                    menuPosition="fixed"
                                                                    styles={{
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            whiteSpace: "nowrap",
                                                                            overflow: "hidden",
                                                                            textOverflow: "clip",
                                                                        }),
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            width: 150,
                                                                        }),

                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            width: 200,
                                                                        }),
                                                                    }}
                                                                    onChange={(selectedOption) => {
                                                                        handleInputUp(
                                                                            "country",
                                                                            entityIdx,
                                                                            selectedOption ? selectedOption.value : ''
                                                                        )
                                                                    }}
                                                                />
                                                            </td>
                                                            <td><input type="text" className="form-control" onChange={(e) => { handleInputUp("office", entityIdx, e.target.value) }} value={entity.office ? entity.office : ""} /></td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="d-flex page-nation-align">
                                    <span className="d-flex align-items-center gap-2">
                                        <label
                                            htmlFor="perPageUp"
                                            className="d-none d-sm-block"
                                        >
                                            Entries per page
                                        </label>
                                        <div style={{ width: "100px" }} className="d-none d-sm-block">
                                            <select
                                                className="form-select"
                                                name="perPageUp"
                                                onChange={e => { viewContactsListUp(1, e.target.value); }}
                                                value={filterValidation.values.perPageUp}
                                            >
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="30">30</option>
                                                <option value="40">40</option>
                                                <option value="50">50</option>
                                            </select>
                                        </div>
                                    </span>
                                    <span className="d-flex align-items-center gap-2">
                                        <div className="d-flex gap-1">
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { viewContactsListUp(1); }}
                                                disabled={(filterValidation.values.curPageUp == 1)}
                                            >
                                                {"<<"}
                                            </Button>
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { viewContactsListUp(Number(filterValidation.values.curPageUp) - 1); }}
                                                disabled={(filterValidation.values.curPageUp == 1)}
                                            >
                                                {"<"}
                                            </Button>
                                        </div>
                                        Page{" "}
                                        <strong>
                                            {filterValidation.values.curPageUp} of {totalPageUp}
                                        </strong>
                                        <Input
                                            type="number"
                                            min={1}
                                            style={{ width: 70 }}
                                            max={totalPageUp}
                                            name="curPageUp"
                                            defaultValue={filterValidation.values.curPageUp}
                                            value={curPageInputUp}
                                            onChange={(e) => { setCurPageInputUp(e.target.value) }}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    viewContactsListUp(e.target.value);
                                                }
                                            }}
                                            className="d-none d-sm-block"
                                        />
                                        <div className="d-flex gap-1">
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { viewContactsListUp(Number(filterValidation.values.curPageUp) + 1); }}
                                                disabled={(filterValidation.values.curPageUp == totalPageUp)}
                                            >
                                                {">"}
                                            </Button>
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { viewContactsListUp(totalPageUp); }}
                                                disabled={(filterValidation.values.curPageUp == totalPageUp)}
                                            >
                                                {">>"}
                                            </Button>
                                        </div>
                                    </span>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                : null}
        </TabPane>
    )
}

export default UploadedContacts;